import { useGetCustomerCartIdQuery } from "@jti/store/slices/magentoApiSlice";

import { useCheckoutV2Configuration } from "@checkout-v2/shared/providers/CheckoutV2ConfigurationProvider";

import { useCoupons } from "./hooks";
import { PromoCodeView } from "./PromoCodeView";

export const PromoCodeContainer = () => {
  const { data } = useGetCustomerCartIdQuery();
  const cartId = data?.customerCart?.id;

  const checkoutV2Configuration = useCheckoutV2Configuration();
  const { hidePromoCodeBlock } = checkoutV2Configuration.general;

  const {
    coupons,
    errors,
    canApplyCoupons,
    onAddCoupon,
    onRemoveCoupon,
    onRemoveAllCoupons,
    resetApplyCoupons,
    isLoading,
  } = useCoupons({ cartId, skip: hidePromoCodeBlock });

  if (hidePromoCodeBlock) {
    return null;
  }

  return (
    <PromoCodeView
      isPending={isLoading}
      items={coupons}
      errors={errors}
      onAddCoupon={onAddCoupon}
      onRemoveCoupon={onRemoveCoupon}
      onRemoveAllCoupons={onRemoveAllCoupons}
      onFocusInput={resetApplyCoupons}
      isAttemptsLimitReached={!canApplyCoupons}
    />
  );
};
